import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import TimelinePeriodNav from './TimelinePeriodNav';
var TimelineControls = React.memo(function (_a) {
    var canGoNext = _a.canGoNext, canGoPrev = _a.canGoPrev, counterCurrent = _a.counterCurrent, counterTotal = _a.counterTotal, onNext = _a.onNext, onPrev = _a.onPrev;
    return (_jsxs("div", { className: "timeline__controls", children: [_jsxs("div", { className: "timeline__counter", children: [counterCurrent, "/", counterTotal] }), _jsx(TimelinePeriodNav, { canGoNext: canGoNext, canGoPrev: canGoPrev, onNext: onNext, onPrev: onPrev })] }));
});
TimelineControls.displayName = 'TimelineControls';
export default TimelineControls;
